import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import "./Navbar.css";
import BixtonLogo from "../assets/Bixton-logo.png.webp";
import CalculatorModal from "./CalculatorModal";

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const location = useLocation();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const isProductsActive = location.pathname.startsWith("/products");

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  // Lock body scroll when mobile menu open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isMenuOpen]);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          {/* Logo */}
          <div className="navbar-logo">
            <NavLink to="/">
              <img src={BixtonLogo} alt="Bixton Logo" />
            </NavLink>
          </div>

          {/* Hamburger */}
          <div
            className={`navbar-hamburger ${isMenuOpen ? "open" : ""}`}
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-label="Toggle menu"
            role="button"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </div>

          {/* Navigation Links */}
          <div className={`navbar-links ${isMenuOpen ? "open" : ""}`}>
            {/* About */}
            <NavLink
              to="/about-us"
              className={({ isActive }) =>
                `navbar-link ${isActive ? "active-link" : ""}`
              }
              onClick={() => setIsMenuOpen(false)}
            >
              ABOUT
            </NavLink>

            {/* Products */}
            <NavLink
              to="/products"
              className={({ isActive }) =>
                `navbar-link ${
                  isActive || isProductsActive ? "active-link" : ""
                }`
              }
              onClick={() => setIsMenuOpen(false)}
            >
              PRODUCTS
            </NavLink>

            {/* Careers */}
            <NavLink
              to="/careers"
              className={({ isActive }) =>
                `navbar-link ${isActive ? "active-link" : ""}`
              }
              onClick={() => setIsMenuOpen(false)}
            >
              CAREERS
            </NavLink>

            {/* Blog */}
            <NavLink
              to="/blog"
              className={({ isActive }) =>
                `navbar-link ${isActive ? "active-link" : ""}`
              }
              onClick={() => setIsMenuOpen(false)}
            >
              BLOG
            </NavLink>

            {/* Contact */}
            <NavLink
              to="/contact-us"
              className={({ isActive }) =>
                `navbar-link ${isActive ? "active-link" : ""}`
              }
              onClick={() => setIsMenuOpen(false)}
            >
              CONTACT
            </NavLink>

            {/* CTA */}
            <div className="navbar-cta">
              <button
                className="cta-button"
                onClick={() => {
                  setIsMenuOpen(false);
                  openModal();
                }}
              >
                CALCULATOR
              </button>
            </div>
          </div>
        </div>
      </nav>

      {isModalOpen && <CalculatorModal onClose={closeModal} />}
    </>
  );
};

export default Navbar;
